import { useState, useContext, Fragment } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Box,
} from '@mui/material';

import RoleContext from '../auth/RoleContext';
import FeatureFlagsContext from '../config/FeatureFlagsContext';
import CacheContext from '../cache/CacheContext';

import { getAuthenticator, getToken, logout } from '../auth/auth';
import { cleanup } from '../auth/role';
import { Stage } from '../config/config';
import Cache from '../cache/Cache';
import { useSessionStorage } from '../utils/ReactUtils';
import ProfileAvatarCard from '../communityHub/ArticleComponents/ProfileAvatarCard';
import { FeatureFlagsToggle } from './FeatureFlagsToggle';
import { RoleImpersonatorToggle } from './RoleImpersonatorToggle';

const SessionTools = ({ layoutStyle, linkStyle }) => {
  const roleCtx = useContext(RoleContext);
  const featureFlagsContext = useContext(FeatureFlagsContext);
  const cacheContext = useContext(CacheContext);

  const [account] = useState(getAuthenticator().getCurrentAccount());
  const [graphToken, setGraphToken] = useSessionStorage('mockGraphToken', null);
  const [open, setOpen] = useState(false);

  const clearCache = () => {
    cacheContext.removeAll()
    Cache.removeAll()
  }

  const handleLogout = (e) => {
    e.preventDefault();
    cleanup();
    logout();
  };

  return (
    <>
      {/* Header tools */}
      <span style={layoutStyle}>
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => setOpen(true)}
        >
          <ProfileAvatarCard avatarLeftRight='right' profileEmail={account?.idTokenClaims?.preferred_username} avatarHeight={30} avatarWidth={30} hideTitle={true} />
          {/* Welcome {account?.name || ''}! */}
        </span>
        <span>
          <button
            type="button"
            onClick={handleLogout}
            style={{
              ...linkStyle,
              background: 'transparent',
              border: 'none',
              // padding: 0,
              cursor: 'pointer',
              font: 'inherit'
            }}
          >
            Logout
          </button>
        </span>
      </span>

      {/* Session dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>NAOU QSE Portal Session Info</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} alignItems={'center'}>
            <Grid item xs={4}>
              <Typography fontWeight="bold" textAlign="right">
                Name:
              </Typography>
            </Grid>
            <Grid item xs={7.5}>
              <Typography>{account?.name || 'null'}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontWeight="bold" textAlign="right">
                Username:
              </Typography>
            </Grid>
            <Grid item xs={7.5}>
              <Typography>{account?.username || 'null'}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontWeight="bold" textAlign="right">
                Email:
              </Typography>
            </Grid>
            <Grid item xs={7.5}>
              <Typography>{account?.idTokenClaims?.mail || 'null'}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontWeight="bold" textAlign="right">
                Department:
              </Typography>
            </Grid>
            <Grid item xs={7.5}>
              <Typography>
                {account?.idTokenClaims?.department || 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography fontWeight="bold" textAlign="right">
                NAOU QSE Portal Role:
              </Typography>
            </Grid>
            <Grid item xs={7.5}>
              <Typography>{roleCtx?.role?.name || 'No roles'}</Typography>
            </Grid>

            {Stage !== 'prod' && (
              <>
              <Grid item xs={4}>
                  <Typography fontWeight="bold" textAlign="right">
                    Test Session Token:
                  </Typography>
              </Grid>
              <Grid item xs={7.5}>
                  <TextField
                    fullWidth
                    value={graphToken || ''}
                    InputLabelProps={{
                      sx: { background: 'none !important' },
                    }}
                    onFocus={(e) => {
                      e.target.value = null;
                      setGraphToken(null);
                    }}
                    onChange={(e) => setGraphToken(e.target.value)}
                  />
              </Grid>
              </>
            )}

            {Stage === 'prod' && roleCtx?.isAdminUser() && (
              <>
              <Grid item xs={4}>
                  <Typography fontWeight="bold" textAlign="right">
                    Copy Session Token:
                  </Typography>
              </Grid>
              <Grid item xs={7.5}>
                <Button
                  variant="text"
                  onClick={async () => {
                    const cachedToken = await getToken(true);
                    navigator.clipboard.writeText(cachedToken.accessToken);
                  }}
                >
                  Copy to Clipboard
                </Button>
              </Grid>
              </>
            )}

            {roleCtx?.isAdminUserDespiteImpersonation() && <Grid item xs={12} textAlign='center'>
                <FeatureFlagsToggle />
                <RoleImpersonatorToggle />
            </Grid>}

            {(roleCtx && !roleCtx.isAdminUserDespiteImpersonation()) && (roleCtx.isInternalUser() || roleCtx.isBottlerUser()) && (!roleCtx.isSupplyChainBottlerUser()) &&
              ['communityHub'].map((flagName) => {
                const flagValue =
                  featureFlagsContext.featureFlags[flagName];

                return (
                  <Fragment key={flagName}>
                    <Grid item xs={4}>
                        <Typography fontWeight="bold" textAlign="right">
                          Feature Flags:
                        </Typography>
                    </Grid>
                    <Grid item xs={7.5}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!flagValue}
                          onChange={(e) => {
                            clearCache();
                            featureFlagsContext.setFlag(
                              flagName,
                              e.target.checked
                            );
                          }}
                        />
                      }
                      label={flagName}
                    />
                  </Grid>
                  </Fragment>
                );
              })}
          </Grid>

          <Box sx={{ mt: 2, textAlign: 'right' }}>
            <Button onClick={() => setOpen(false)}>Close</Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SessionTools;